(function () {
  'use strict'

  /**
   * @ngdoc service
   * @name CartApi
   * @module thismoment.glow.component.glow-cart.provider.cart-api
   *
   * @description
   * Allows the glow page and glow modules to access the user input
   */

  var MODULE_NAME = 'thismoment.glow.component.glow-cart.provider.cart-api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../../../api/async')
    ])
    .provider('CartApi', cartApiProvider)

  function cartApiProvider () {
    return {
      $get: cartApiService
    }
  }

  cartApiService.$inject = ['SdkConfig', 'ThismomentAsyncApi']
  function cartApiService (SdkConfig, ThismomentAsyncApi) {
    var API = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/solution/v1/glow/send-cart')

    return {
      send: sendCart
    }

    function sendCart (data, contents) {
      var postBody = angular.merge({
        account_id: SdkConfig.get('account_id'),
        group_id: SdkConfig.get('group_id'),
        glow_id: SdkConfig.get('solution_id'),
        content_ids: contents
      }, data)

      return API.post({}, postBody)
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-cart/provider/cart-api.js